<template>
  <div v-if="paramId && bundle">
    <el-page-header
      v-if="instance"
      content="Install a new application"
      @back="$emit('back')"
    />

    <el-card v-if="instance" class="bundle-backups" :shadow="shadow">
      <el-row :gutter="15">
        <el-col :span="instance ? 16 : 12">
          <div class="question">Enable automatic backups
            <span v-if="instance">at an additional {{ $root.currency.symbol }}{{ cost }} /month</span> ?
          </div>
        </el-col>

        <el-col :span="instance ? 8 : 12" align="right">
          <el-radio-group
            v-model="form.backup"
            :disabled="loading"
            type="info"
            size="mini"
            text-color="#ffffff"
            fill="#383838"
          >
            <el-radio-button label="1">Enable</el-radio-button>
            <el-radio-button label="0">I don't want backups</el-radio-button>
          </el-radio-group>
        </el-col>
      </el-row>
    </el-card>

    <el-card v-loading="loading" :shadow="shadow">
      <h4 v-if="instance" slot="header">Finalize your application</h4>

      <el-row :gutter="15">
        <el-col :span="instance ? 16 : 24">
          <el-select
            class="app"
            v-model="form.version"
            v-bind:class="{ [paramId]: true }"
            size="small"
          >
            <el-option
              v-for="version in bundle.versions"
              :key="version"
              :label="'Version ' + version"
              :value="version"
            />
          </el-select>

          <el-select
            v-if="bundle.package"
            class="package"
            v-model="form.pkgVersion"
            size="small"
          >
            <el-option
              v-for="version in packages[paramId]"
              :key="version"
              :label="bundle.name + ' ' + version"
              :value="version"
            />
          </el-select>
        </el-col>

        <el-col v-if="instance" :span="8" class="align-right">
          <el-button type="primary" :loading="loading" @click.prevent="deploy">
            Install {{ bundle.name }}
          </el-button>
        </el-col>
      </el-row>
    </el-card>

    <Instruction
      v-if="instance"
      :bundle-id="paramId"
      class="instruction"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Instruction from '../Application/Instruction'

export default {
  props: {
    instance: Object,
    bundleId: String,
    shadow: {
      type: String,
      default: 'always'
    }
  },
  components: {
    Instruction
  },
  data () {
    return {
      loading: false,
      form: {
        backup: '1',
        domains: [],
        version: null,
        pkgVersion: null
      }
    }
  },
  mounted () {
    this.form.version = this.bundle.versions[0]
    if (this.bundle.package) {
      this.form.pkgVersion = this.packages[this.paramId][0]
    }
  },
  computed: {
    cost () {
      return Math.ceil(this.instance.storage.size / 10) + '.00'
    },
    paramId () {
      return this.bundleId || this.$route.params.bundleId
    },
    bundle () {
      return this.$root.bundles[this.paramId]
    },
    ...mapState(['packages'])
  },
  methods: {
    deploy () {
      this.loading = true
      this.$store.dispatch('deployApplication', {
        instanceId: this.instance.id,
        bundleId: this.paramId,
        ...this.form
      }).then(() => this.$router.push('/instances/' + this.instance.id))
        .catch(() => {
          this.loading = false
        })
    }
  },
  beforeMount () {
    if (!this.paramId || !this.$root.bundles[this.paramId] ||
      this.$root.bundles[this.paramId].disabled || this.$root.bundles[this.paramId].database) {
      this.$emit('back')
    }
  },
  watch: {
    'paramId' () {
      this.$nextTick(() => {
        this.form.version = this.bundle.versions[0]
        if (this.bundle.package) {
          this.form.pkgVersion = this.packages[this.paramId][0]
        } else {
          this.form.pkgVersion = null
        }
      })
    },
    'form.version' (value) {
      this.$emit('update:version', value)
    },
    'form.pkgVersion' (value) {
      this.$emit('update:pkgVersion', value)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../theme";

  .app {
    background-repeat: no-repeat;
    margin: 0;
    padding: 5px 0 5px 50px;
    font-weight: 400;
    font-size: 20px;
    background-size: 30px;
    background-position: left;
  }
  .package {
    margin-left: 10px;
  }
  .instruction {
    margin-top: 30px;
  }
  .el-card {
    margin-bottom: 15px;

    h4 {
      margin: 0;

      .el-tag {
        float: right;
      }
    }
    .question {
      line-height: 28px;
    }

    &.is-always-shadow {
      .question {
        font-weight: 500;
      }
    }

    &.is-hover-shadow:hover {
      border-color: transparent;
    }
  }
</style>

<style lang="scss">
  .bundle-domain.el-message-box {
    width: 560px
  }
  .bundle-backups {
    .el-radio-button__inner {
      color: #383838;
    }
  }
</style>
